import { useSession, useEditorState, useNode } from "../state/context.js";
import type { EditorActions } from "../state/actions.js";
import { NodeInspector } from "./NodeInspector.js";
import { DocumentInspector } from "./DocumentInspector.js";
import { Icon } from "../ui/icons.js";
import { Button } from "../ui/primitives.js";

export function Inspector({ actions }: { actions: EditorActions }) {
  const session = useSession();
  const selection = useEditorState((s) => s.selection);
  const mode = useEditorState((s) => s.mode);
  const entry = useNode(selection[0] ?? null);
  if (mode === "preview") {
    return (
      <aside className="bpe-inspector" aria-label="Properties">
        <div className="bpe-empty" style={{ marginTop: 40 }}>
          <Icon name="eye" />
          <div className="bpe-empty__title">Preview mode</div>
          Properties are hidden while previewing. Switch back to Design to edit.
          <Button size="sm" onClick={() => session.setMode("design")} style={{ marginTop: 8 }}>Back to design</Button>
        </div>
      </aside>
    );
  }
  if (selection.length > 1) {
    return (
      <aside className="bpe-inspector" aria-label="Properties">
        <div className="bpe-inspector__header">
          <span className="bpe-inspector__icon"><Icon name="square-stack" /></span>
          <div><div className="bpe-inspector__title">{selection.length} blocks selected</div><div className="bpe-inspector__subtitle">Actions apply to all</div></div>
        </div>
        <div className="bpe-prop-grid">
          <Button icon="copy" onClick={() => actions.duplicateSelection()}>Duplicate all</Button>
          <Button icon="panel-top" onClick={() => actions.wrapSelectionIn("card")}>Wrap in card</Button>
          <Button icon="link" onClick={() => actions.wrapSelectionIn("keepTogether")}>Keep together</Button>
          <Button icon="trash" variant="danger" onClick={() => actions.deleteSelection()}>Delete all</Button>
        </div>
      </aside>
    );
  }
  return (
    <aside className="bpe-inspector" aria-label="Properties">
      {entry ? <NodeInspector key={entry.node.id} entry={entry} actions={actions} /> : <DocumentInspector />}
    </aside>
  );
}
